/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class KupiService {
    /**
     * Kupi import XML
     * @returns any Kupi import XML
     * @throws ApiError
     */
    public static getApiVKupiImportXml({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/kupi/import.xml',
            path: {
                'apiVersion': apiVersion,
            },
        });
    }
    /**
     * Kupi market XML
     * @returns any Kupi import poboček
     * @throws ApiError
     */
    public static getApiVKupiImportPobocekXml({
        identifier,
        apiVersion = 1,
    }: {
        identifier: string,
        apiVersion?: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/kupi/import-pobocek/{identifier}.xml',
            path: {
                'apiVersion': apiVersion,
                'identifier': identifier,
            },
        });
    }
    /**
     * Kupi letak XML
     * @returns any Kupi import letáků
     * @throws ApiError
     */
    public static getApiVKupiImportLetakuXml({
        identifier,
        apiVersion = 1,
    }: {
        identifier: string,
        apiVersion?: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/kupi/import-letaku/{identifier}.xml',
            path: {
                'apiVersion': apiVersion,
                'identifier': identifier,
            },
        });
    }
    /**
     * Kupi letak XML
     * @returns any Kupi import akčního zboží
     * @throws ApiError
     */
    public static getApiVKupiImportAkcnihoZboziXml({
        identifier,
        apiVersion = 1,
    }: {
        identifier: string,
        apiVersion?: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/kupi/import-akcniho-zbozi/{identifier}.xml',
            path: {
                'apiVersion': apiVersion,
                'identifier': identifier,
            },
        });
    }
}
